import { format } from 'date-fns/format';
import { startOfMonth } from 'date-fns-jalali/startOfMonth';
import { endOfMonth } from 'date-fns-jalali/endOfMonth';
import { getDate } from 'date-fns-jalali/getDate';
import { getYear } from 'date-fns-jalali/getYear';
import { getMonth } from 'date-fns-jalali/getMonth';
import { endOfDay } from 'date-fns-jalali/endOfDay';
import { startOfDay } from 'date-fns-jalali/startOfDay';

export function getStartOfCurrentMonth() {
  const date = startOfDay(startOfMonth(new Date()));
  return {
    str: format(date, 'yyyy-MM-dd'),
    date: {
      year: getYear(date),
      month: getMonth(date) + 1,
      day: getDate(date),
    }
  };
}

export function getEndOfCurrentMonth() {
  const date = endOfDay(endOfMonth(new Date()));
  return {
    str: format(date, 'yyyy-MM-dd'),
    date: {
      year: getYear(date),
      month: getMonth(date) + 1,
      day: getDate(date),
    }
  };
}
